exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main[data-v-7bedf709]{display:grid;grid-template-columns:20% 80%}.left-div[data-v-7bedf709]{border-right:1px solid #999;overflow-y:auto;display:grid;grid-template-columns:repeat(1,1fr);grid-template-rows:repeat(auto-fill,50px);-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly;justify-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.left-div div[data-v-7bedf709]{margin-bottom:10px}button[data-v-7bedf709]{width:200px}.title[data-v-7bedf709]{margin-left:2em;cursor:default}.back[data-v-7bedf709]{position:absolute;right:15px;cursor:pointer}.right-div[data-v-7bedf709]{overflow-y:auto;padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7bedf709","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/formBuilder/formDemos/index.vue
// module id = A7jZ
// module chunks = 0